import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('census', '/censuses')
const actions = generator.generate()

export default actions
